import React from "react";

const index = () => {
  return <div>media</div>;
};

export default index;
